var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "11",
    height: "10",
    viewBox: "0 0 11 10"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3799EB",
    fillRule: "evenodd",
    d: "M7.18 5.03l3.24-3.27a.984.984 0 0 0 0-1.4c-.38-.39-1-.39-1.39 0L5.79 3.63 2.55.36a.972.972 0 0 0-1.39 0c-.38.39-.38 1.01 0 1.4L4.4 5.03 1.16 8.29c-.38.39-.38 1.02 0 1.41a.978.978 0 0 0 1.39 0l3.24-3.27L9.03 9.7a.978.978 0 0 0 1.39 0 .996.996 0 0 0 0-1.41L7.18 5.03z"
  }));
};